import { useState, useEffect, useRef } from 'react'
// @ts-ignore
import { store } from '@sportninja/common/store'

/**
 * Lightweight useSelector replacement for react-redux@5.
 * Subscribes to the Redux store and re-renders when the selected value changes.
 */
export function useSelector<T>(selector: (state: any) => T): T {
  const [value, setValue] = useState<T>(() => selector(store.getState()))
  const selectorRef = useRef(selector)
  selectorRef.current = selector

  useEffect(() => {
    const checkForUpdates = () => {
      const newValue = selectorRef.current(store.getState())
      setValue((prev) => {
        if (prev === newValue) return prev
        return newValue
      })
    }

    const unsubscribe = store.subscribe(checkForUpdates)
    // Check once in case state changed between render and subscribe
    checkForUpdates()
    return unsubscribe
  }, [])

  return value
}

/**
 * Lightweight useDispatch replacement for react-redux@5.
 */
export function useDispatch() {
  return store.dispatch
}
